import type { DashboardSummaryDto } from '@nova/shared';
import { useQuery } from '@tanstack/react-query';
import { api, query } from '../lib/api.js';
import { useFilterParams } from './FilterProvider.js';
import type { SystemStatus } from '../components/NovaOrb.js';

/**
 * Feeds the Nova orb in the rail and top bar. Derived server-side in
 * /dashboard/summary so every surface agrees on what "alt vel" means.
 */
export function useSystemStatus(): SystemStatus {
  const params = useFilterParams();
  const { data } = useQuery({
    queryKey: ['dashboard', params],
    queryFn: () => api.get<DashboardSummaryDto>(`/dashboard/summary${query(params)}`),
    refetchInterval: 30_000,
  });
  return data?.systemStatus ?? 'OK';
}
